import { render } from "./Statistical.vue?vue&type=template&id=425a9eb4&scoped=true"
import script from "./Statistical.vue?vue&type=script&lang=js"
export * from "./Statistical.vue?vue&type=script&lang=js"

import "./Statistical.vue?vue&type=style&index=0&id=425a9eb4&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425a9eb4"]])

export default __exports__